import { Store } from "../../../../@core/store/store";

export class ProfileLoadingState extends Store.AbstractLoadingState<any> { }
export class ProfileLoadingErrorState extends Store.AbstractErrorState<any> { }
export class ProfileLoadedState extends Store.AbstractIdealState<any> { }

export class RequestsForApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForApprovalsLoadedState extends Store.AbstractIdealState<any> { }

export class RequestsForAttendanceApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForAttendanceApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForAttendanceApprovalsLoadedState extends Store.AbstractIdealState<any> { }


export class RequestsForLeaveApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForLeaveApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForLeaveApprovalsLoadedState extends Store.AbstractIdealState<any> { }

export class RequestsForCarApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForCarApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForCarApprovalsLoadedState extends Store.AbstractIdealState<any> { }

export class RequestsForAccommodationApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForAccommodationApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForAccommodationApprovalsLoadedState extends Store.AbstractIdealState<any> { }

export class SynergyPendingRequestsLoadingState extends Store.AbstractLoadingState<any> { }
export class SynergyPendingRequestsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class SynergyPendingRequestsLoadedState extends Store.AbstractIdealState<any> { }

export class ForexPendingRequestsLoadingState extends Store.AbstractLoadingState<any> { }
export class ForexPendingRequestsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class ForexPendingRequestsLoadedState extends Store.AbstractIdealState<any> { }

export class MyRequestLoadingState extends Store.AbstractLoadingState<any> { }
export class MyRequestLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyRequestLoadedState extends Store.AbstractIdealState<any> { }